var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPointStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 66,
    viewBox: "0 0 40 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_988_12807)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 64,
    rx: 8,
    ry: 2,
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 39,
    width: 4,
    height: 27,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    filter: "url(#filter0_f_988_12807)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 25.5,
    r: 18,
    fill: "black"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22,
    r: 20,
    fill: "#FA1861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9477 26.9671C23.5802 28.3224 21.9371 29 20.0184 29C18.0997 29 16.4505 28.3224 15.0707 26.9671C13.6902 25.6118 13 23.9561 13 22C13 20.0755 13.6902 18.4276 15.0707 17.0561C16.4505 15.6854 18.0936 15 20 15C21.9251 15 23.5731 15.6841 24.9439 17.0523C26.3146 18.4198 27 20.0752 27 22.0184C27 23.9622 26.3159 25.6118 24.9477 26.9671Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_988_12807",
    x: -2,
    y: 3.5,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_988_12807"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_988_12807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 66,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointStartIcon);
export default __webpack_public_path__ + "static/media/PointStartIcon.d450757a6cc08d106e3c12165014b9b5.svg";
export { ForwardRef as ReactComponent };